import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=55491f00&"
import script from "./FileBrowser.vue?vue&type=script&lang=js&"
export * from "./FileBrowser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports